'use strict'
var values = require('./values')
module.exports = function (object) {
  return values(Object.keys(object))
}





//////////////////
// WEBPACK FOOTER
// ./~/pull-stream/sources/keys.js
// module id = 393
// module chunks = 0